module.exports = __webpack_public_path__ + "static/media/A194822C-6BDF-4828-A7D6-C9AAAECF3E41-min.aa72fb9c.jpg";